// extracted by mini-css-extract-plugin
export default {"upload-footer-inbox-text":"E3dLXoMUPUk_YnJKB4No"};